// extracted by mini-css-extract-plugin
export default {"base":"styles__base--TQRul","horizontal-padding":"styles__horizontal-padding--KEYPq","small":"styles__small---eqIk","medium":"styles__medium--T4OHl","large":"styles__large--CJrwt"};